// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "game-paper-fly" + "." + "ca1c1545" + ".chunk.css";
};